import HistoryCard from './HistoryCard';
import NoData from '@/widget/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import { ITransferData } from '../../hooks/useTransferHistoryList';

interface IProps {
  loading: boolean;
  transferMap: { [key: string]: ITransferData[] };
}

export default (props: IProps) => {
  const { loading, transferMap } = props;
  return loading ? (
    [...new Array(8)].map((_, index) => {
      return (
        <div className="flex items-center justify-between h-[66px] border-b-[1px] border-borderColor" key={index}>
          <div className="flex-1">
            <Skeleton className="h-[42px] w-[80%] rounded-xl" />
          </div>
          <div className="flex-1 flex justify-end">
            <Skeleton className="h-[42px] w-[80%] rounded-xl" />
          </div>
        </div>
      );
    })
  ) : Object.keys(transferMap).length > 0 ? (
    <div className="">
      {Object.keys(transferMap).map((date) => {
        return <HistoryCard key={date} data={transferMap[date]} date={date} />;
      })}
    </div>
  ) : (
    <NoData />
  );
};
